var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit93(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25.16,48.5l4.41-9.57c.12-.27.29-.51.5-.72l27.66-27.29c.57-.57,1.5-.56,2.07,0l4.23,4.23c.57.57.57,1.49,0,2.07l-27.29,27.66c-.21.21-.45.38-.72.5l-9.57,4.41c-.83.38-1.68-.47-1.3-1.3ZM54.26,14.36l6.29,6.29-6.29-6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m54.6,38.05v22.28c0,2.3-1.87,4.17-4.17,4.17H14.71c-2.3,0-4.17-1.87-4.17-4.17V24.82c0-2.3,1.87-4.17,4.17-4.17h23.69"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.04,
    y: 0
  }, "dit"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit93);
export default __webpack_public_path__ + "static/media/__Edit-93.5e9eec813902e16fe9471286bfcb7e4e.svg";
export { ForwardRef as ReactComponent };